import { render, staticRenderFns } from "./a-td.vue?vue&type=template&id=8b28a482&"
import script from "./a-td.vue?vue&type=script&lang=js&"
export * from "./a-td.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports